<app-breadcrumb *ngIf="!disableBreadcrumb" [master]="'Struktura sieci'" [parentName]="'Umowy'"
                [name]="'TU (załączniki do umowy)'"></app-breadcrumb>
<div class="contract-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="contract-list-filters">
    <ng-container *ngIf="!disableFilters">
      <app-dict-all-contracts
        [multiple]="false" label="Umowa"
        class="contract-list-filter contract-list-filter-long"
        [(ngModel)]="initialFilters.contract" name="contract"
      ></app-dict-all-contracts>
      <app-dict
        [multiple]="false"
        [dictType]="'contract_type'"
        [label]="'Rodzaj umowy'"
        class="contract-list-filter"
        [(ngModel)]="initialFilters.type"
        name="type"
      ></app-dict>

      <app-dict
        [multiple]="false" [dictType]="'company'"
        [label]="'Firma'" class="contract-list-filter"
        [(ngModel)]="initialFilters.company" name="company"
      ></app-dict>

      <app-dict-commission-tables
        *ngIf="(userPermissions | async).commission_table.read"
        class="contract-list-filter"
        [(ngModel)]="initialFilters.commissionTable"
        name="commissionTable"
        [commissionTables]="commissionTables"
        [required]="false"
        label="Standard"
      ></app-dict-commission-tables>

      <app-dict-insurance-companies
        [multiple]="true" label="TU" class="contract-list-filter"
        [(ngModel)]="initialFilters.in$insuranceCompany" name="in$insuranceCompany"
      ></app-dict-insurance-companies>

      <mat-form-field appearance="standard" class="contract-list-filter" *ngIf="sent === null">
        <mat-label>Wysłany</mat-label>
        <mat-select [(ngModel)]="initialFilters.sent" name="sent">
          <mat-option [value]="null">Wszystkie</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="standard" class="contract-list-filter" *ngIf="signed === null">
        <mat-label>Podpisany</mat-label>
        <mat-select [(ngModel)]="initialFilters.signed" name="signed">
          <mat-option [value]="null">Wszystkie</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="standard" class="contract-list-filter" *ngIf="returned === null">
        <mat-label>Zwrócony</mat-label>
        <mat-select [(ngModel)]="initialFilters.returned" name="returned">
          <mat-option [value]="null">Wszystkie</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

      <app-dict-regionals
        [multiple]="false" [label]="'Regionalny (majątek)'"
        class="contract-list-filter"
        [(ngModel)]="initialFilters.assetsRegional" name="assetsRegional"
      ></app-dict-regionals>

      <app-dict-ofwcas
        [multiple]="false" label="OFWCA"
        class="contract-list-filter contract-list-filter-long"
        [(ngModel)]="initialFilters.ofwca" name="ofwca"
      ></app-dict-ofwcas>

      <app-dict-partners
        [multiple]="false" [label]="'Partner'"
        class="contract-list-filter contract-list-filter-long"
        [(ngModel)]="initialFilters.partner" name="partner"
      ></app-dict-partners>

      <app-dict
        [multiple]="false" [dictType]="'contract_status'"
        [label]="'Status'" class="contract-list-filter"
        [(ngModel)]="initialFilters.status" name="status"
        [onlyKeys]="statusKeys ? statusKeys : undefined"
      ></app-dict>

      <app-datepicker
        class="contract-list-filter"
        label="Data utworzenia od"
        placeholder="2000-01-01"
        [required]="false"
        [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"
      ></app-datepicker>

      <app-datepicker
        class="contract-list-filter"
        label="Data utworzenia do"
        placeholder="2000-01-01"
        [required]="false"
        [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"
      ></app-datepicker>

      <mat-form-field appearance="standard" class="contract-list-filter">
        <mat-label>Brak rejestracji do załącznika</mat-label>
        <mat-select [(ngModel)]="initialFilters.disabled" name="disabled">
          <mat-option [value]="null">Wszystkie</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="standard" class="contract-list-filter">
        <mat-label>Aktywna rejestracja pod umową</mat-label>
        <mat-select [(ngModel)]="initialFilters.hasActiveRegistrations" name="hasActiveRegistrations">
          <mat-option [value]="null">Wszystkie</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>

    <app-datepicker
      class="contract-list-filter"
      label="Umowa aktywna od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.contractActiveAt" name="contractActiveAt"
    ></app-datepicker>

    <app-datepicker
      class="contract-list-filter"
      label="Umowa aktywna do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.contractActiveTo" name="contractActiveTo"
    ></app-datepicker>

    <app-datepicker
      class="contract-list-filter"
      label="Data utworzenia Partnera od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.partnerCreatedAt" name="partnerCreatedAt"
    ></app-datepicker>

    <app-datepicker
      class="contract-list-filter"
      label="Data utworzenia Partnera do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.partnerCreatedTo" name="partnerCreatedTo"
    ></app-datepicker>

    <mat-form-field appearance="standard" class="contract-list-filter">
      <mat-label>Partner nowy</mat-label>
      <mat-select [(ngModel)]="initialFilters.newPartner" name="newPartner">
        <mat-option [value]="null">Wszystkie</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field  *ngIf="disableFilters" appearance="standard" style="min-width: 240px;">
      <mat-label>Widok kolumn</mat-label>
      <mat-select multiple [value]="selectedColumnValues" (selectionChange)="columnSelectionChanged($event.value)">
        <mat-select-trigger>{{ columnsSelectionLabel }}</mat-select-trigger>
        <mat-option [value]="selectAllColumnsValue">Zaznacz wszystkie</mat-option>
        <mat-option *ngFor="let column of availableColumnDefinitions" [value]="column.key">
          {{ column.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </form>

  <div *ngIf="!disableFilters"
       fxLayout="row"
    fxLayoutAlign="space-between center"
    fxLayoutGap="16px"
  >
    <mat-form-field  appearance="standard" style="min-width: 240px;">
      <mat-label>Widok kolumn</mat-label>
      <mat-select multiple [value]="selectedColumnValues" (selectionChange)="columnSelectionChanged($event.value)">
        <mat-select-trigger>{{ columnsSelectionLabel }}</mat-select-trigger>
        <mat-option [value]="selectAllColumnsValue">Zaznacz wszystkie</mat-option>
        <mat-option *ngFor="let column of availableColumnDefinitions" [value]="column.key">
          {{ column.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div   class="contract-list-buttons" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="16px">
      <button *ngIf="(userPermissions | async).contract.read_report"
              [disabled]="!(userPermissions | async).contract.read_report"
              mat-raised-button [matMenuTriggerFor]="generate" class="report-button">
        <mat-icon>download</mat-icon>
        Pobierz raport
      </button>
      <mat-menu #generate="matMenu">
        <button *ngIf="(userPermissions | async).contract.read_report"
                [disabled]="!(userPermissions | async).contract.read_report" mat-menu-item (click)="downloadReport()">
          Pobierz raport
        </button>
        <button *ngIf="(userPermissions | async).contract.read_report"
                [disabled]="!(userPermissions | async).contract.read_report" mat-menu-item
                (click)="downloadAdditionalReport()">Pobierz raport - Dodatkowy
        </button>
      </mat-menu>
      <!--    <button (click)="downloadReport()" [disabled]="!(userPermissions | async).contract.read_report"-->
      <!--            mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>-->
      <button (click)="filter()" mat-raised-button color="primary">
        <mat-icon>search</mat-icon>
        <span> Szukaj</span></button>
      <button (click)="resetFilters()" mat-raised-button color="warn">
        <mat-icon>delete</mat-icon>
        <span> Resetuj filtry</span></button>
    </div>
  </div>

  <table mat-table [dataSource]="contractInsuranceCompanies">
    <ng-container matColumnDef="logo">
      <th mat-header-cell *matHeaderCellDef [width]="'150px'"> Logo</th>
      <td mat-cell *matCellDef="let element" style="text-align: center">
        <img *ngIf="element.insuranceCompany.imageLocation"
             src="/rest/crm/insuranceCompany/{{element.insuranceCompany.id}}/image" alt="Zdjęcie" height="30"/>
      </td>
    </ng-container>

    <!-- Position Column -->
    <ng-container matColumnDef="insuranceCompany">
      <th mat-header-cell *matHeaderCellDef> TU</th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link"
           [routerLink]="['/tu/szczegoly', element.insuranceCompany.id]">{{ element.insuranceCompany.name }}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="contract">
      <th mat-header-cell *matHeaderCellDef> Umowa</th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link"
           [routerLink]="['/umowy/szczegoly', element.contract.uuid]">{{ element.contract.number }}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="sent">
      <th mat-header-cell *matHeaderCellDef> Wysłany</th>
      <td mat-cell *matCellDef="let element">
        <mat-slide-toggle
          [disabled]="!(userPermissions | async).contract.write || updateInProgress"
          [checked]="element.sent" (change)="formChanged(
            $event,
            element,
            {sent: $event.checked, returned: element.returned, note: element.note, signed: element.signed}
          )"></mat-slide-toggle>
      </td>
    </ng-container>

    <ng-container matColumnDef="returned">
      <th mat-header-cell *matHeaderCellDef> Zwrócony</th>
      <td mat-cell *matCellDef="let element">
        <mat-slide-toggle
          [disabled]="!(userPermissions | async).contract.write || updateInProgress || !element.sent"
          [checked]="element.returned" (change)="formChanged(
            $event,
            element,
            {sent: element.sent, returned: $event.checked, note: element.note, signed: element.signed}
        )"></mat-slide-toggle>
      </td>
    </ng-container>

    <ng-container matColumnDef="signed">
      <th mat-header-cell *matHeaderCellDef> Podpisany</th>
      <td mat-cell *matCellDef="let element">
        <mat-slide-toggle
          [disabled]="!(userPermissions | async).contract.write || updateInProgress || !element.sent"
          [checked]="element.signed" (change)="formChanged(
            $event,
            element,
            {sent: element.sent, returned: element.returned, note: element.note, signed: $event.checked}
        )"></mat-slide-toggle>
      </td>
    </ng-container>

    <ng-container matColumnDef="activeRegistration">
      <th mat-header-cell *matHeaderCellDef> Aktywna rejestracja pod umową</th>
      <td mat-cell *matCellDef="let element">
        <mat-slide-toggle
          [disabled]="true"
          [checked]="element.hasActiveRegistrations"></mat-slide-toggle>
      </td>
    </ng-container>

    <ng-container matColumnDef="party">
      <th mat-header-cell *matHeaderCellDef> Partner/OFWCA</th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.contract.partner">
          <a class="default-link"
             [routerLink]="['/partnerzy/szczegoly', element.contract.partner?.uuid]">{{ element.contract.partner?.shortName }}</a>
        </ng-container>

        <ng-container *ngIf="element.contract.ofwca">
          <a class="default-link"
             [routerLink]="['/ofwca/szczegoly', element.contract.ofwca?.uuid]">{{ element.contract.ofwca.fullName }}</a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status</th>
      <td mat-cell *matCellDef="let element">
        <button mat-raised-button
                [ngClass]="element.contract.status.color + '-button'">{{ element.contract.status.name }}
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="assetsRegional">
      <th mat-header-cell *matHeaderCellDef> Regionalny (majątek)</th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.contract.partner">
          {{ element.contract.partner.assetsRegional?.firstName }} {{ element.contract.partner.assetsRegional?.lastName }}
        </ng-container>

        <ng-container *ngIf="element.contract.ofwca">
          {{ element.contract.ofwca.assetsRegional?.firstName }} {{ element.contract.ofwca.assetsRegional?.lastName }}
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef> Data utworzenia</th>
      <td mat-cell *matCellDef="let element">
        {{ element.createdAt | date:'y-MM-dd' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="sentAt">
      <th mat-header-cell *matHeaderCellDef> Data wysłania</th>
      <td mat-cell *matCellDef="let element">
        {{ element.sentAt | date:'y-MM-dd H:mm' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="note">
      <th mat-header-cell *matHeaderCellDef> Uwagi</th>
      <td mat-cell *matCellDef="let element">
        <mat-form-field>
          <mat-label>Uwagi</mat-label>
          <textarea
            style="height: 50px"
            [disabled]="!(userPermissions | async).contract.write || updateInProgress"
            (focusout)="noteChanged($event, element)" matInput [value]="element.note"></textarea>
        </mat-form-field>
      </td>
    </ng-container>
    <ng-container matColumnDef="standard">
      <th mat-header-cell *matHeaderCellDef>Standard</th>
      <td mat-cell *matCellDef="let element">
        <app-dict-commission-tables
          *ngIf="commissionTableControls[element.uuid]"
          [control]="commissionTableControls[element.uuid]"
          [commissionTables]="commissionTables"
          [companyId]="element.contract.company.id"
          [contractTypeId]="element.contract.type.id"
          [disable]="!(userPermissions | async).commission_table.write || updateInProgress"
          label="Standard"
          [showClear]="false"
          (selectedCommissionTable)="commissionTableChanged(element,$event)"
        ></app-dict-commission-tables>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button
          mat-icon-button [matMenuTriggerFor]="menu"
        >
          <mat-icon>expand_more</mat-icon>
        </button>
        <mat-menu #menu="matMenu" xPosition="before">
          <button
            [disabled]="!(userPermissions | async).contract.delete || (element.sent && element.signed)"
            mat-menu-item
            (click)="deleteInsuranceCompany(element)"
          >
            Usuń
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns; let element"
        [class.disabled-contract-insurance-company]="!element.hasActiveRegistrations"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
